(function () {
  'use strict';
  // 本预览以hash管理页面，避免重载时浏览器恢复旧滚动位置覆盖route的页首定位。
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  const content = window.siteContent;
  const emptyImage = { src: '', thumb: '', type: 'whole', label: 'Artwork', caption: 'Image to be added', alt: 'Artwork image to be added' };
  const products = (Array.isArray(content.products) ? content.products : [content.product]).filter(function (entry) { return entry && entry.sku; }).filter(function (entry, index, entries) { return entries.findIndex(function (other) { return other.sku === entry.sku; }) === index; });
  products.forEach(function (entry) {
    entry.slug = entry.slug || (entry === content.product ? 'blue-lattice' : '');
    entry.title = entry.title || 'Artwork title to be added';
    entry.images = (entry.images || []).map(function (asset) { asset = asset || {}; return Object.assign({}, asset, { src: asset.src || '', type: asset.type || 'whole', label: asset.label || 'Artwork', caption: asset.src ? (asset.caption || 'Artwork image') : 'Image to be added', alt: asset.alt || 'Artwork image' }); });
    if (!entry.images.length) entry.images = [Object.assign({}, emptyImage)];
    entry.sizes = (entry.sizes || []).filter(function (size) { return size && size.id && size.label; });
    if (!entry.sizes.length) entry.sizes = [{ id: 'standard', label: 'Standard', measurements: '', unitPrice: null }];
  });
  const defaultProduct = products.find(function (entry) { return content.product && entry.sku === content.product.sku; }) || products[0];
  let product = defaultProduct;
  let currentProductRoute = '';
  const imageAsset = function (index) { return product.images[index] || emptyImage; };
  const imageListeners = new WeakSet();
  const main = document.getElementById('main');
  const header = document.getElementById('site-header');
  const menu = document.getElementById('menu-dialog');
  const drawer = document.getElementById('drawer-dialog');
  const gallery = document.getElementById('gallery-dialog');
  const dialogs = [menu, drawer, gallery];
  // v2 bag and v1 results remain untouched. Their single-product shape is not
  // imported into this catalogue, so old examples cannot acquire a new identity.
  const storageKey = 'felt-moooi-english-preview-v3';
  let currentPage = '';
  let pageCleanup = null;
  let imageIndex = 0;
  let quantity = 1;
  let bagQuantity = 0;
  let bagItems = [];
  let selectedSize = product.sizes[0].id;
  let storageFailed = false;
  let zoom = 1;
  let pan = { x: 0, y: 0 };
  let gesture = null;
  let toastTimer;
  let previousScroll = window.scrollY;
  let scrollScheduled = false;
  const openers = new WeakMap();
  const closingCleanups = new WeakMap();

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]; });
  }
  const standalonePages = ['home', 'product', 'collection', 'about', 'stories', 'story', 'faq', 'contact', 'bag', 'checkout', 'order-result', 'shipping-and-returns', 'privacy', 'cookies', 'terms'];
  function getHref(target) {
    const base = window.FELT_ROOT || '/';
    if (target === 'home') return base;
    if (target.indexOf('product/') === 0) return base + 'products/' + encodeURIComponent(window.FELT_HANDLE(target.slice(8)));
    if (target.indexOf('story/') === 0) return base + 'pages/story?story=' + encodeURIComponent(target.slice(6));
    if (target.indexOf('order-result/') === 0) return base + 'cart';
    const parts = target.split('?');
    const query = parts[1] ? '?' + parts.slice(1).join('?') : '';
    if (parts[0] === 'collection') return base + 'collections/all' + query;
    if (parts[0] === 'bag') return base + 'cart' + query;
    if (parts[0] === 'checkout') return base + 'checkout';
    if (standalonePages.includes(parts[0])) return base + 'pages/' + parts[0] + query;
    return base;
  }
  function getProduct(reference) {
    const value = reference && typeof reference === 'object' ? (reference.sku || reference.slug) : reference;
    return products.find(function (entry) { return entry.sku === value || entry.slug === value; }) || null;
  }
  function getProductUrl(reference) {
    const entry = reference == null ? defaultProduct : getProduct(reference);
    return entry && entry.slug ? getHref('product/' + entry.slug) : getHref('collection');
  }
  function locationRoute() {
    // Shopify decides the page in Liquid (window.FELT_ROUTE); the hash only scrolls.
    const routeInfo = window.FELT_ROUTE || { key: 'home' };
    const hash = location.hash.slice(1);
    let key = routeInfo.key || 'not-found';
    if (key === 'native') return { key: 'native', productSlug: '', anchor: '' };
    if (key === 'story') {
      const stories = window.feltPageContent && window.feltPageContent.stories && window.feltPageContent.stories.items || [];
      key = 'story/' + (new URLSearchParams(location.search).get('story') || (stories[0] && stories[0].slug) || 'a-pattern-reimagined');
    }
    const productSlug = key === 'product' ? window.FELT_SLUG(routeInfo.handle || '') : '';
    if (key !== 'product' && !standalonePages.includes(key.split('/')[0])) key = 'not-found';
    return { key: key, productSlug: productSlug, anchor: hash };
  }
  function navigate(target) {
    // Every Shopify URL is its own page: load it rather than redrawing in place.
    const url = new URL(getHref(target), location.href);
    if (url.href !== location.href) { location.href = url.href; return; }
    closeDialogs();
    route(true);
  }
  function pageContext() {
    return {
      content: content, product: product, products: products, getProduct: getProduct, escape: escapeHTML, getHref: getHref,
      getProductUrl: getProductUrl,
      formatPrice: formatPrice, applyImage: applyImage, navigate: navigate, notify: notify,
      getBag: function () { return { items: bagItems.map(function (item) { return Object.assign({}, item); }), quantity: bagQuantity, storageFailed: storageFailed }; },
      setBagQuantity: function (sku, sizeId, value) {
        const item = bagItems.find(function (record) { return record.sku === sku && record.size === sizeId; });
        if (!item || !Number.isInteger(value) || value < 1 || value > 9 || bagQuantity - item.quantity + value > 9) { notify('You can order up to 9 pieces at a time.'); return false; }
        item.quantity = value; saveBag(); return true;
      },
      removeBag: function (sku, sizeId) { bagItems = bagItems.filter(function (record) { return record.sku !== sku || record.size !== sizeId; }); saveBag(); },
      clearBag: function () { bagItems = []; saveBag(); }
    };
  }

  function textElement(tag, text, className) {
    const node = document.createElement(tag);
    node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function copyValue(key) {
    const parts = key.split('.');
    return parts.reduce(function (value, part, index) { return index === 0 && part === 'product' ? product : value && value[part]; }, content);
  }
  function fillContent(root) {
    root.querySelectorAll('[data-copy]').forEach(function (node) {
      const value = copyValue(node.dataset.copy);
      if (value !== undefined && value !== null) node.textContent = value || 'To be added';
    });
    root.querySelectorAll('[data-dimensions-summary]').forEach(function (node) {
      const values = ['Width', 'Height', 'Depth'].map(function (key) { return (product.dimensions || {})[key]; });
      node.textContent = values.every(function (value) { return value && value !== 'To be added'; }) ? values.join(' × ') : 'To be added';
    });
    root.querySelectorAll('[data-image-index]').forEach(function (image) {
      const asset = image.closest('#story') ? { src: content.story.image, alt: content.story.imageAlt } : imageAsset(Number(image.dataset.imageIndex));
      applyImage(image, asset, image.hasAttribute('data-small'));
      if (image.closest('#story')) { const storyCaption = image.closest('#story').querySelector('.media-caption'); if (storyCaption) storyCaption.textContent = content.story.imageAlt; }
      if (!asset.src) { const section = image.closest('section'); const caption = section && section.querySelector('.media-caption'); if (caption) caption.textContent = 'Image to be added'; }
    });
    root.querySelectorAll('a[href="product.html"]').forEach(function (link) { link.href = getProductUrl(defaultProduct); });
    const storySection = root.querySelector('#story');
    if (storySection && content.story.productSlug) {
      storySection.classList.add('song-lotus-detail');
      const storyImage = storySection.querySelector('.macro-image img');
      if (storyImage && content.story.mobileImage && storyImage.parentElement.tagName !== 'PICTURE') {
        const picture = document.createElement('picture');
        const source = document.createElement('source');
        source.media = '(max-width: 1000px)';
        source.srcset = content.story.mobileImage;
        storyImage.replaceWith(picture);
        picture.append(source, storyImage);
      }
      const storyLink = storySection.querySelector('.pill-button');
      if (storyLink) storyLink.href = getProductUrl(content.story.productSlug);
    }
    const heroImage = root.querySelector('[data-home-image]');
    if (heroImage) {
      applyImage(heroImage, { src: content.hero.desktopImage, alt: content.hero.alt });
      { const heroCaption = heroImage.closest('.home-hero').querySelector('.media-caption'); if (heroCaption) heroCaption.textContent = content.hero.alt; }
      if (content.hero.mobileImage) root.querySelector('[data-home-mobile]').srcset = content.hero.mobileImage;
      document.documentElement.style.setProperty('--hero-desktop-position', content.hero.desktopPosition);
      document.documentElement.style.setProperty('--hero-mobile-position', content.hero.mobilePosition);
      setImageFallback(heroImage);
      drawHeroVideo(root);
      const heroProduct = products.find(function (entry) { return entry.slug === content.hero.productSlug; }) || defaultProduct;
      const heroProductLink = heroImage.closest('.home-hero').querySelector('.pill-button');
      if (heroProductLink) heroProductLink.href = getProductUrl(heroProduct);
    }
  }
  function drawHeroVideo(root) {
    const hero = root.querySelector('.home-hero');
    const source = window.innerWidth <= 700 ? (content.hero.mobileVideo || content.hero.desktopVideo) : content.hero.desktopVideo;
    if (!hero || !source) return;
    const video = document.createElement('video'); video.className = 'hero-video'; video.muted = true; video.loop = true; video.playsInline = true; video.preload = 'metadata'; video.poster = content.hero.desktopImage || ''; video.src = source;
    const control = textElement('button', 'Play', 'video-control'); control.dataset.videoControl = ''; control.hidden = true; control.setAttribute('aria-label', 'Play video');
    function sync() { control.textContent = video.paused ? 'Play' : 'Pause'; control.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video'); }
    video.addEventListener('play', sync); video.addEventListener('pause', sync);
    video.addEventListener('loadeddata', function () { control.hidden = false; sync(); });
    video.addEventListener('error', function () { video.hidden = true; control.hidden = true; });
    hero.append(video, control);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(function () { sync(); });
  }
  function setImageFallback(image) {
    if (imageListeners.has(image)) return;
    imageListeners.add(image);
    image.addEventListener('error', function () {
      image.hidden = true;
      let note = image.parentElement.querySelector('.image-fallback');
      if (!note) { note = textElement('span', 'Image to be added', 'image-fallback'); image.parentElement.append(note); }
      note.hidden = false;
    });
    image.addEventListener('load', function () {
      image.hidden = false;
      const note = image.parentElement.querySelector('.image-fallback');
      if (note) note.hidden = true;
    });
  }
  function applyImage(image, asset, small) {
    setImageFallback(image);
    image.alt = asset.alt || '';
    const source = small ? (asset.thumb || asset.src) : asset.src;
    if (source) image.src = source;
    else { image.removeAttribute('src'); image.hidden = true; if (image.parentElement && !image.parentElement.querySelector('.image-fallback')) image.parentElement.append(textElement('span', 'Image to be added', 'image-fallback')); }
  }
  function drawHomeSections() {
    const cards = document.getElementById('category-cards');
    (content.collection.categories || []).forEach(function (category, index) {
      const link = document.createElement('a'); link.className = 'view-card'; link.href = getHref('collection');
      const picture = document.createElement('span'); picture.className = 'card-picture category-' + category.tone;
      if (category.image) { const image = document.createElement('img'); image.loading = 'lazy'; applyImage(image, { src: category.image, alt: category.alt }); picture.append(image); }
      else { picture.append(textElement('span', String(index + 1).padStart(2, '0'), 'slot-number'), textElement('span', 'Image to be added', 'slot-label')); }
      link.append(picture, textElement('span', category.title)); cards.append(link);
    });
    const container = document.getElementById('home-campaigns');
    (content.campaigns || []).forEach(function (campaign) {
      const section = document.createElement('section'); section.id = campaign.id; section.className = 'feature-story campaign campaign-' + campaign.tone;
      if (campaign.image) {
        const picture = document.createElement('picture'); picture.className = 'campaign-media';
        if (campaign.mobileImage) { const source = document.createElement('source'); source.media = '(max-width: 700px)'; source.srcset = campaign.mobileImage; picture.append(source); }
        const image = document.createElement('img'); image.loading = 'lazy'; image.style.objectPosition = campaign.position || '50% 50%'; applyImage(image, { src: campaign.image, alt: campaign.alt }); picture.append(image); section.append(picture);
        const shade = document.createElement('div'); shade.className = 'campaign-shade'; section.append(shade);
      }
      const copy = document.createElement('div'); copy.className = 'hero-copy';
      const heading = textElement('h2', campaign.title); heading.tabIndex = -1;
      const campaignProduct = products.find(function (product) { return product.slug === campaign.productSlug; }) || defaultProduct;
      const link = textElement('a', campaign.button, 'pill-button'); link.href = campaign.href ? getHref(String(campaign.href).replace(/\.html$/, '')) : getProductUrl(campaignProduct);
      if (campaign.viewIndex !== undefined) link.dataset.viewIndex = String(campaign.viewIndex);
      copy.append(textElement('p', campaign.label, 'eyebrow'), heading, textElement('p', campaign.description, 'hero-description'), link);
      section.append(copy); if (campaign.slot) section.append(textElement('span', campaign.slot, 'media-caption')); container.append(section);
    });
  }
  function currentSize() { return product.sizes.find(function (size) { return size.id === selectedSize; }) || product.sizes[0]; }
  function formatPrice(size, owningProduct) {
    const entry = owningProduct || product;
    if (typeof size.unitPrice === 'number' && Number.isFinite(size.unitPrice) && size.unitPrice >= 0 && /^[A-Z]{3}$/.test(entry.currency || '')) {
      try { return new Intl.NumberFormat('en', { style: 'currency', currency: entry.currency, minimumFractionDigits: Number.isInteger(size.unitPrice) ? 0 : 2 }).format(size.unitPrice); } catch (_) { /* Invalid currency keeps the explicit placeholder. */ }
    }
    return entry.price || 'Price to be added';
  }
  function updateSize() {
    const size = currentSize();
    document.querySelectorAll('[data-size]').forEach(function (input) { input.checked = input.value === size.id; });
    const price = document.getElementById('product-price'); if (price) price.textContent = formatPrice(size);
    document.querySelectorAll('[data-repeat-price]').forEach(function (node) { node.textContent = formatPrice(size); });
    document.querySelectorAll('[data-repeat-size]').forEach(function (node) { node.textContent = 'Size: ' + size.label; });
    const fields = size.dimensions || product.dimensions || {};
    const values = ['Width', 'Height', 'Depth'].map(function (key) { return fields[key]; });
    const summary = values.every(function (value) { return value && value !== 'To be added'; }) ? values.join(' × ') : 'To be added';
    const dimensions = document.querySelector('[data-dimensions-summary]'); if (dimensions) dimensions.textContent = size.measurements || summary;
    updateFloatingPurchaseDetails();
  }
  function drawSizes() {
    const container = document.getElementById('size-options');
    product.sizes.forEach(function (size) {
      const label = document.createElement('label'); label.className = 'size-option';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'artwork-size'; input.value = size.id; input.dataset.size = ''; input.setAttribute('aria-label', size.label);
      const copy = textElement('span', size.label);
      label.append(input, copy); container.append(label);
    });
    updateSize();
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-size]')) { selectedSize = event.target.value; updateSize(); }
  });
  function notify(message) {
    const toast = document.getElementById('toast');
    toast.textContent = message;
    toast.classList.add('visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { toast.classList.remove('visible'); }, 3500);
  }
  function updateBagCount() {
    bagQuantity = bagItems.reduce(function (total, item) { return total + item.quantity; }, 0);
    const count = document.getElementById('bag-count');
    count.textContent = String(bagQuantity);
    count.hidden = bagQuantity === 0;
    document.querySelector('.bag-trigger').setAttribute('aria-label', 'Shopping bag, ' + bagQuantity + (bagQuantity === 1 ? ' item' : ' items'));
  }
  function loadBag() {
    try {
      const record = window.FELT_CART.record();
      bagItems = [];
      if (record && Array.isArray(record.items)) record.items.forEach(function (item) {
        const entry = item && getProduct(item.sku);
        const valid = entry && entry.sku === item.sku && entry.sizes.some(function (size) { return size.id === item.size; }) && Number.isInteger(item.quantity) && item.quantity >= 1 && item.quantity <= 9;
        if (valid && !bagItems.some(function (other) { return other.sku === item.sku && other.size === item.size; }) && bagItems.reduce(function (sum, other) { return sum + other.quantity; }, 0) + item.quantity <= 9) bagItems.push({ sku: entry.sku, size: item.size, quantity: item.quantity });
      });
    } catch (_) { bagItems = []; }
    updateBagCount();
  }
  function saveBag() {
    try {
      window.FELT_CART.sync(bagItems);
      storageFailed = false;
      document.getElementById('storage-warning').hidden = true;
      updateBagCount();
      return true;
    } catch (_) {
      storageFailed = true;
      document.getElementById('storage-warning').hidden = false;
      updateBagCount();
      return false;
    }
  }
  function openDialog(dialog, opener) {
    if (closingCleanups.has(dialog)) closingCleanups.get(dialog)();
    dialog.classList.remove('is-closing');
    if (!dialogs.some(function (other) { return other.open; })) document.documentElement.style.setProperty('--scrollbar-gap', Math.max(0, window.innerWidth - document.documentElement.clientWidth) + 'px');
    let returnTarget = opener || document.activeElement;
    dialogs.forEach(function (other) {
      if (other !== dialog && other.open && other.contains(returnTarget)) returnTarget = openers.get(other) || document.querySelector('.menu-trigger');
    });
    dialogs.forEach(function (other) { if (other !== dialog && other.open) { if (closingCleanups.has(other)) closingCleanups.get(other)(); other.close(); } });
    openers.set(dialog, returnTarget);
    dialog.showModal();
    document.documentElement.classList.add('modal-open');
    syncFloatingPurchase();
    const close = dialog.querySelector('[data-close]');
    if (close) close.focus({ preventScroll: true });
  }
  function closeDialogs() {
    dialogs.forEach(function (dialog) { if (closingCleanups.has(dialog)) closingCleanups.get(dialog)(); if (dialog.open) { openers.delete(dialog); dialog.close(); } });
  }
  function dismissDialog(dialog) {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    let finished = false;
    let timer;
    function cleanup() { finished = true; window.clearTimeout(timer); dialog.removeEventListener('animationend', finish); dialog.classList.remove('is-closing'); closingCleanups.delete(dialog); }
    function finish(event) { if (finished || (event && event.target !== dialog)) return; cleanup(); if (dialog.open) dialog.close(); }
    closingCleanups.set(dialog, cleanup);
    dialog.addEventListener('animationend', finish);
    timer = window.setTimeout(finish, 260);
  }
  dialogs.forEach(function (dialog) {
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismissDialog(dialog); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      const controls = Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (node) { return node.getClientRects().length > 0; });
      if (!controls.length) return;
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismissDialog(dialog);
      }
    });
    dialog.addEventListener('close', function () {
      syncFloatingPurchase();
      if (!dialogs.some(function (other) { return other.open; })) {
        document.documentElement.classList.remove('modal-open');
        const opener = openers.get(dialog);
        if (opener && opener.isConnected) {
          const visibleTarget = opener.getClientRects().length ? opener : document.querySelector('.menu-trigger');
          visibleTarget.focus({ preventScroll: true });
        }
      }
    });
  });
  function resetMenu() {
    document.getElementById('menu-main').hidden = false;
    document.getElementById('menu-products').hidden = true;
    document.getElementById('menu-title').textContent = 'Menu';
  }
  document.getElementById('show-products').addEventListener('click', function () {
    document.getElementById('menu-main').hidden = true;
    document.getElementById('menu-products').hidden = false;
    document.getElementById('menu-title').textContent = 'Collection';
    document.getElementById('back-to-menu').focus();
  });
  document.getElementById('back-to-menu').addEventListener('click', function () {
    resetMenu(); document.getElementById('show-products').focus();
  });

  function appendTable(container, heading, fields) {
    container.append(textElement('h3', heading));
    const table = document.createElement('table');
    table.className = 'data-table';
    table.setAttribute('aria-label', heading);
    const tbody = document.createElement('tbody');
    Object.entries(fields || {}).forEach(function (entry) {
      const row = document.createElement('tr');
      const label = textElement('th', entry[0]);
      label.scope = 'row';
      row.append(label, textElement('td', entry[1] || 'To be added')); tbody.append(row);
    });
    table.append(tbody); container.append(table);
  }
  function drawBag() {
    const container = document.getElementById('drawer-content');
    container.replaceChildren();
    document.getElementById('drawer-title').textContent = 'Shopping bag';
    if (!bagQuantity) {
      const empty = document.createElement('div'); empty.className = 'empty-bag';
      empty.append(textElement('h3', 'Your bag is empty.'), textElement('p', 'Explore the collection and find a piece for your space.'));
      const browse = textElement('a', 'Explore the collection', 'bag-continue'); browse.href = getHref('collection');
      empty.append(browse); container.append(empty);
    } else {
      bagItems.forEach(function (record) {
      const entry = getProduct(record.sku);
      const size = entry.sizes.find(function (size) { return size.id === record.size; });
      const item = document.createElement('div'); item.className = 'bag-item';
      const image = document.createElement('img');
      const info = document.createElement('div');
      const titleLink = textElement('a', entry.title); titleLink.href = getProductUrl(entry);
      const title = document.createElement('h3'); title.append(titleLink);
      info.append(title, textElement('p', 'Size: ' + size.label), textElement('p', formatPrice(size, entry)));
      const controls = document.createElement('div'); controls.className = 'quantity-control';
      [-1, 1].forEach(function (delta, index) {
        const button = textElement('button', delta < 0 ? '−' : '+'); button.dataset.bagQuantity = String(delta);
        button.dataset.bagSize = record.size;
        button.dataset.bagSku = record.sku;
        button.setAttribute('aria-label', (delta < 0 ? 'Decrease ' : 'Increase ') + entry.title + ' ' + size.label + ' bag quantity');
        button.disabled = delta < 0 ? record.quantity === 1 : bagQuantity === 9;
        if (index === 1) { const value = textElement('span', String(record.quantity), 'quantity-value'); value.setAttribute('aria-live', 'polite'); controls.append(value); }
        controls.append(button);
      });
      const remove = textElement('button', 'Remove', 'bag-remove'); remove.dataset.remove = record.size; remove.dataset.bagSku = record.sku; remove.setAttribute('aria-label', 'Remove ' + size.label + ' ' + entry.title);
      info.append(controls, remove); item.append(image, info); container.append(item); applyImage(image, content.placeholderMedia[entry.slug].commerce, true);
      });
      const firstProduct = getProduct(bagItems[0].sku);
      const pricesReady = /^[A-Z]{3}$/.test(firstProduct.currency || '') && bagItems.every(function (record) { const entry = getProduct(record.sku); const size = entry.sizes.find(function (size) { return size.id === record.size; }); return entry.currency === firstProduct.currency && typeof size.unitPrice === 'number' && Number.isFinite(size.unitPrice) && size.unitPrice >= 0; });
      const total = pricesReady ? formatPrice({ unitPrice: bagItems.reduce(function (sum, record) { return sum + getProduct(record.sku).sizes.find(function (size) { return size.id === record.size; }).unitPrice * record.quantity; }, 0) }, firstProduct) : 'Price to be added';
      const summary = document.createElement('div'); summary.className = 'bag-summary'; summary.append(textElement('span', 'Subtotal'), textElement('span', total)); container.append(summary);
      const checkout = textElement('a', 'Checkout', 'add-button bag-checkout'); checkout.href = getHref('checkout'); container.append(checkout);
      const fullBag = textElement('a', 'View shopping bag', 'bag-continue'); fullBag.href = getHref('bag'); container.append(fullBag);
      const browse = textElement('a', 'Continue shopping', 'bag-continue'); browse.href = getHref('collection'); container.append(browse);
    }
    container.append(textElement('p', 'Shipping and taxes are calculated at checkout.', 'panel-note'));
    if (storageFailed) {
      const warning = textElement('p', 'We could not update your bag. Please refresh the page and try again.', 'panel-note');
      warning.id = 'bag-storage-warning'; warning.setAttribute('role', 'alert'); container.append(warning);
    }
  }
  function showPanel(type, opener) {
    const container = document.getElementById('drawer-content');
    container.replaceChildren();
    if (type === 'bag') drawBag();
    else if (type === 'dimensions') {
      document.getElementById('drawer-title').textContent = 'Dimensions';
      appendTable(container, 'Artwork dimensions', currentSize().dimensions || product.dimensions);
      container.prepend(textElement('p', 'Selected size: ' + currentSize().label, 'selected-dimensions'));
      appendTable(container, 'Packaging dimensions', currentSize().packaging || product.packaging);
      container.append(textElement('p', 'Weights and box sizes are approximate. Each piece is handmade, so measurements may vary slightly.', 'panel-note'));
    } else if (type === 'specifications') {
      document.getElementById('drawer-title').textContent = 'Specifications';
      appendTable(container, 'Product specifications', product.specifications);
    } else {
      const panel = content[type];
      document.getElementById('drawer-title').textContent = panel.heading;
      container.append(textElement('p', panel.text, 'drawer-paragraph'));
      if (type === 'contact' && panel.email) {
        const link = textElement('a', panel.email, 'text-link'); link.href = 'mailto:' + panel.email; container.append(link);
      }
      if (type === 'shipping' || type === 'contact') {
        const more = textElement('a', type === 'shipping' ? 'Read shipping & returns' : 'Contact us', 'text-link'); more.href = getHref(type === 'shipping' ? 'shipping-and-returns' : 'contact'); container.append(more);
      }
    }
    drawer.dataset.panel = type;
    openDialog(drawer, opener);
  }

  function imageClass(type) { return type === 'whole' ? '' : 'is-' + type; }
  function updatePrimaryImage() {
    const image = document.getElementById('primary-image');
    if (!image) return;
    const asset = imageAsset(imageIndex);
    applyImage(image, asset);
    document.getElementById('primary-display').className = 'primary-display ' + imageClass(asset.type);
    document.getElementById('inline-counter').textContent = (imageIndex + 1) + ' / ' + product.images.length;
    document.getElementById('primary-caption').textContent = asset.caption;
    document.querySelectorAll('[data-thumbnail]').forEach(function (button) { button.setAttribute('aria-pressed', String(Number(button.dataset.thumbnail) === imageIndex)); });
  }
  function drawThumbnails() {
    const container = document.getElementById('thumbnail-row');
    const productGallery = document.querySelector('.product-gallery');
    // Keep the desktop strip with the image it controls rather than below both columns.
    productGallery.append(container);
    const navigation = document.createElement('div'); navigation.id = 'product-image-navigation'; navigation.className = 'product-image-navigation';
    const dots = document.createElement('div'); dots.id = 'product-image-dots'; dots.className = 'product-image-dots';
    dots.setAttribute('role', 'group'); dots.setAttribute('aria-label', 'Product image navigation');
    navigation.append(dots, textElement('p', 'Swipe to explore', 'product-swipe-hint'));
    productGallery.append(navigation);
    product.images.forEach(function (asset, index) {
      const button = document.createElement('button');
      button.className = 'thumbnail-button ' + imageClass(asset.type);
      button.dataset.thumbnail = String(index);
      button.setAttribute('aria-label', 'Show ' + String(asset.label || 'Artwork').toLowerCase() + ' image');
      const image = document.createElement('img'); button.append(image); container.append(button); applyImage(image, { src: asset.thumb || asset.src, alt: '' });
      const dot = document.createElement('button'); dot.className = 'product-image-dot'; dot.type = 'button'; dot.dataset.thumbnail = String(index);
      dot.setAttribute('aria-label', 'Show image ' + (index + 1) + ' of ' + product.images.length + ', ' + String(asset.label || 'Artwork').toLowerCase());
      dots.append(dot);
    });
  }
  function updateFloatingPurchaseDetails() {
    const card = document.getElementById('floating-purchase');
    if (!card) return;
    const size = currentSize();
    card.querySelector('.floating-purchase-size').textContent = size.label;
    card.querySelector('.floating-purchase-price').textContent = formatPrice(size);
    card.querySelector('[data-add]').setAttribute('aria-label', 'Add ' + quantity + ' ' + product.title + ' to bag');
  }
  function syncFloatingPurchase() {
    const card = document.getElementById('floating-purchase');
    if (!card) return;
    const purchase = document.querySelector('.purchase-section');
    const description = document.querySelector('.product-description');
    const visible = currentPage === 'product' && purchase && description && !dialogs.some(function (dialog) { return dialog.open; }) && purchase.getBoundingClientRect().bottom <= 0 && description.getBoundingClientRect().top < window.innerHeight;
    card.hidden = !visible;
    if (visible) {
      const cardHeight = Math.ceil(card.getBoundingClientRect().height);
      if (cardHeight > 0 && card.dataset.reserveHeight !== String(cardHeight)) {
        card.dataset.reserveHeight = String(cardHeight);
        document.documentElement.style.setProperty('--floating-purchase-height', cardHeight + 'px');
      }
    }
  }
  function mountProductInteractions() {
    const card = document.createElement('aside'); card.id = 'floating-purchase'; card.className = 'floating-purchase'; card.hidden = true;
    card.setAttribute('aria-label', 'Artwork purchase');
    const summary = document.createElement('div'); summary.className = 'floating-purchase-summary';
    const image = document.createElement('img'); image.className = 'floating-purchase-image';
    const copy = document.createElement('div'); copy.className = 'floating-purchase-copy';
    copy.append(textElement('p', product.title, 'floating-purchase-title'), textElement('p', '', 'floating-purchase-size'));
    summary.append(image, copy, textElement('p', '', 'floating-purchase-price'));
    const add = textElement('button', 'Add to bag', 'floating-purchase-button add-button'); add.type = 'button'; add.dataset.add = '';
    card.append(summary, add); main.append(card);
    applyImage(image, imageAsset(0), true);
    updateFloatingPurchaseDetails();

    const photo = document.getElementById('open-gallery');
    let swipe = null;
    let suppressClickUntil = 0;
    const removers = [];
    function listen(type, handler, options) { photo.addEventListener(type, handler, options); removers.push(function () { photo.removeEventListener(type, handler, options); }); }
    function beginSwipe(x, y, id) {
      swipe = null;
      if (!window.matchMedia('(max-width:700px)').matches || dialogs.some(function (dialog) { return dialog.open; })) return false;
      swipe = { x: x, y: y, id: id, direction: '' }; return true;
    }
    function trackSwipe(x, y) {
      if (!swipe) return false;
      const dx = Math.abs(x - swipe.x); const dy = Math.abs(y - swipe.y);
      if (!swipe.direction && Math.max(dx, dy) > 10) swipe.direction = dx > dy * 1.5 ? 'horizontal' : 'vertical';
      return swipe.direction === 'horizontal';
    }
    function endSwipe(x, y) {
      if (!swipe) return;
      const dx = x - swipe.x; const dy = y - swipe.y;
      const horizontal = trackSwipe(x, y);
      if (horizontal && Math.abs(dx) > 10) suppressClickUntil = Date.now() + 500;
      if (horizontal && Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        changeImage(dx < 0 ? 1 : -1, false);
      }
      swipe = null;
    }
    // A swipe must not bubble into the photo's gallery-opening click.
    listen('click', function (event) {
      if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    if ('PointerEvent' in window) {
      listen('pointerdown', function (event) {
        if (event.button !== 0 || event.isPrimary === false || !beginSwipe(event.clientX, event.clientY, event.pointerId)) return;
        if (photo.setPointerCapture) photo.setPointerCapture(event.pointerId);
      });
      listen('pointermove', function (event) { if (swipe && swipe.id === event.pointerId) trackSwipe(event.clientX, event.clientY); }, { passive: true });
      listen('pointerup', function (event) { if (swipe && swipe.id === event.pointerId) endSwipe(event.clientX, event.clientY); });
      listen('pointercancel', function () { swipe = null; });
      listen('lostpointercapture', function () { swipe = null; });
    } else {
      listen('touchstart', function (event) {
        if (event.touches.length !== 1) { swipe = null; return; }
        const touch = event.touches[0]; beginSwipe(touch.clientX, touch.clientY, touch.identifier);
      }, { passive: true });
      listen('touchmove', function (event) {
        if (!swipe) return;
        const touch = Array.from(event.touches).find(function (entry) { return entry.identifier === swipe.id; });
        if (touch && trackSwipe(touch.clientX, touch.clientY) && event.cancelable) event.preventDefault();
      }, { passive: false });
      listen('touchend', function (event) {
        if (!swipe) return;
        const touch = Array.from(event.changedTouches).find(function (entry) { return entry.identifier === swipe.id; });
        if (touch) endSwipe(touch.clientX, touch.clientY);
      }, { passive: true });
      listen('touchcancel', function () { swipe = null; }, { passive: true });
    }
    return function () { removers.forEach(function (remove) { remove(); }); swipe = null; card.remove(); document.documentElement.style.removeProperty('--floating-purchase-height'); };
  }
  function updateQuantity() {
    const input = document.getElementById('product-quantity');
    if (!input) return;
    input.value = quantity;
    document.querySelector('[data-quantity="-1"]').disabled = quantity === 1;
    document.querySelector('[data-quantity="1"]').disabled = quantity === 9;
    updateFloatingPurchaseDetails();
  }
  function updateZoom() {
    document.getElementById('gallery-transform').style.transform = 'translate(' + pan.x + 'px,' + pan.y + 'px) scale(' + zoom + ')';
    document.getElementById('gallery-stage').style.cursor = zoom > 1 ? 'grab' : 'default';
    document.getElementById('zoom-out').disabled = zoom === 1;
    document.getElementById('zoom-in').disabled = zoom === 3;
  }
  function updateGalleryImage() {
    const asset = imageAsset(imageIndex);
    const image = document.getElementById('gallery-image'); applyImage(image, asset);
    document.getElementById('gallery-display').className = 'gallery-display ' + imageClass(asset.type);
    document.getElementById('gallery-counter').textContent = (imageIndex + 1) + ' / ' + product.images.length;
    document.getElementById('gallery-caption').textContent = asset.caption;
    zoom = 1; pan = { x: 0, y: 0 }; updateZoom();
    updatePrimaryImage();
  }
  function changeImage(delta, fullScreen) {
    imageIndex = (imageIndex + delta + product.images.length) % product.images.length;
    if (fullScreen) updateGalleryImage(); else updatePrimaryImage();
  }
  document.getElementById('zoom-in').addEventListener('click', function () {
    zoom = 3; pan = { x: 0, y: 0 }; updateZoom(); document.getElementById('zoom-out').focus({ preventScroll: true });
  });
  document.getElementById('zoom-out').addEventListener('click', function () {
    zoom = 1; pan = { x: 0, y: 0 }; updateZoom(); document.getElementById('zoom-in').focus({ preventScroll: true });
  });
  gallery.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); changeImage(event.key === 'ArrowLeft' ? -1 : 1, true); }
  });
  const stage = document.getElementById('gallery-stage');
  stage.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    gesture = { x: event.clientX, y: event.clientY, panX: pan.x, panY: pan.y, pointerId: event.pointerId };
    stage.setPointerCapture(event.pointerId);
    if (zoom > 1) stage.classList.add('is-panning');
  });
  stage.addEventListener('pointermove', function (event) {
    if (!gesture || event.pointerId !== gesture.pointerId || zoom === 1) return;
    const bounds = document.getElementById('gallery-display');
    const maxX = bounds.offsetWidth * (zoom - 1) / 2;
    const maxY = bounds.offsetHeight * (zoom - 1) / 2;
    pan.x = Math.max(-maxX, Math.min(maxX, gesture.panX + event.clientX - gesture.x));
    pan.y = Math.max(-maxY, Math.min(maxY, gesture.panY + event.clientY - gesture.y));
    updateZoom();
  });
  stage.addEventListener('pointerup', function (event) {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    if (zoom === 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) changeImage(dx < 0 ? 1 : -1, true);
    gesture = null; stage.classList.remove('is-panning');
  });
  stage.addEventListener('pointercancel', function () { gesture = null; stage.classList.remove('is-panning'); });

  function syncHeader() {
    const y = window.scrollY;
    const announcement = document.getElementById('announcement');
    const visibleNotice = announcement.hidden ? 0 : Math.max(0, announcement.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--header-offset', visibleNotice + 'px');
    const hero = document.querySelector('.home-hero,.pages-story-hero');
    header.classList.toggle('on-hero', !!hero && y < 80);
    if (y < 100 || y < previousScroll - 2) header.classList.remove('header-hidden');
    else if (y > previousScroll + 2 && y > 150) header.classList.add('header-hidden');
    previousScroll = y;
    syncFloatingPurchase();
  }
  window.addEventListener('scroll', function () {
    if (!scrollScheduled) { scrollScheduled = true; window.requestAnimationFrame(function () { syncHeader(); scrollScheduled = false; }); }
  }, { passive: true });
  window.addEventListener('resize', syncHeader);
  // 商品详情页下半部分（2026-10-20，参考 Moooi 商品页）：纹样出处 / 手作质感 / 画框 / 实际尺寸 / 摆放 / 更多作品 / 相关故事 / 工作室
  function drawProductDetails() {
    const root = document.getElementById('product-details');
    const all = content.productDetails || {};
    const shared = all.shared || {};
    const detail = all[product.slug];
    if (!root || !detail) { if (root) root.hidden = true; return; }
    const e = escapeHTML;
    const helpers = window.FELT_PAGES && window.FELT_PAGES.helpers;
    const ctx = pageContext();
    const img = function (asset) { return asset && asset.src ? asset.src : ''; };
    function figure(src, alt, className, caption, slotText) {
      return '<figure class="pd-media' + (className ? ' ' + className : '') + '">' +
        (src ? '<img src="' + e(src) + '" alt="' + e(alt || '') + '" loading="lazy" decoding="async">' : '<div class="pd-slot"><span>' + e(slotText || 'Image to be added') + '</span></div>') +
        (caption ? '<figcaption>' + e(caption) + '</figcaption>' : '') + '</figure>';
    }
    function copyBlock(block, extra, className) {
      return '<div class="pd-copy' + (className ? ' ' + className : '') + '"><p class="eyebrow">' + e(block.label || '') + '</p><h2>' + e(block.title || '') + '</h2>' +
        (block.paragraphs || (block.text ? [block.text] : [])).map(function (text) { return '<p>' + e(text) + '</p>'; }).join('') + (extra || '') + '</div>';
    }
    function sizeDiagram() {
      const size = detail.frame || {};
      const outer = size.ratio === '30cm' ? 30 : 25, open = size.ratio === '30cm' ? 15.4 : 10.4, k = 10, pad = 30, gap = 70;
      const a4w = 21.59 * k, a4h = 27.94 * k, fw = outer * k, ow = open * k;
      const top = 46, width = pad * 2 + a4w + gap + fw, height = top + Math.max(a4h, fw) + 70;
      const base = top + Math.max(a4h, fw), fx = pad + a4w + gap, fy = base - fw, ox = fx + (fw - ow) / 2, oy = fy + (fw - ow) / 2;
      const mainImage = img(product.images[0]), box = size.openBox;
      return '<svg class="pd-diagram" viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="' + e(product.title + ' framed artwork, ' + (size.size || '') + ', shown to scale beside a US Letter sheet') + '">' +
        '<defs><clipPath id="pd-open"><rect x="' + ox + '" y="' + oy + '" width="' + ow + '" height="' + ow + '"/></clipPath></defs>' +
        '<rect x="' + pad + '" y="' + (base - a4h) + '" width="' + a4w + '" height="' + a4h + '" fill="#f7f4ee" stroke="#c9c2b6" stroke-width="1.5"/>' +
        '<text x="' + (pad + a4w / 2) + '" y="' + (base - a4h / 2) + '" text-anchor="middle" class="pd-diagram-muted">Letter</text>' +
        '<text x="' + (pad + a4w / 2) + '" y="' + (base + 30) + '" text-anchor="middle" class="pd-diagram-label">US Letter · 8.5 × 11 in</text>' +
        '<rect x="' + fx + '" y="' + fy + '" width="' + fw + '" height="' + fw + '" fill="' + (size.frameFill || '#2d2b29') + '" stroke="' + (size.edgeStroke || '#a8673d') + '" stroke-width="2.5"/>' +
        (mainImage && box ? (function () { const sx = ow / (box[2] - box[0]), sy = ow / (box[3] - box[1]); return '<image href="' + e(mainImage) + '" x="' + (ox - box[0] * sx) + '" y="' + (oy - box[1] * sy) + '" width="' + (1254 * sx) + '" height="' + (1254 * sy) + '" preserveAspectRatio="none" clip-path="url(#pd-open)"/>'; })() : '<rect x="' + ox + '" y="' + oy + '" width="' + ow + '" height="' + ow + '" fill="#e8e5df"/>') +
        '<rect x="' + ox + '" y="' + oy + '" width="' + ow + '" height="' + ow + '" fill="none" stroke="' + (size.edgeStroke || '#a8673d') + '" stroke-width="2"/>' +
        '<line x1="' + fx + '" y1="' + (fy - 14) + '" x2="' + (fx + fw) + '" y2="' + (fy - 14) + '" class="pd-dim"/><line x1="' + fx + '" y1="' + (fy - 20) + '" x2="' + fx + '" y2="' + (fy - 8) + '" class="pd-dim"/><line x1="' + (fx + fw) + '" y1="' + (fy - 20) + '" x2="' + (fx + fw) + '" y2="' + (fy - 8) + '" class="pd-dim"/>' +
        '<text x="' + (fx + fw / 2) + '" y="' + (fy - 24) + '" text-anchor="middle" class="pd-diagram-label">' + e((outer / 2.54).toFixed(1) + ' in') + '</text>' +
        '<text x="' + (fx + fw / 2) + '" y="' + (base + 30) + '" text-anchor="middle" class="pd-diagram-label">' + e('Framed artwork · ' + (size.svgSize || size.size || '')) + '</text>' +
        '<text x="' + (fx + fw / 2) + '" y="' + (base + 52) + '" text-anchor="middle" class="pd-diagram-muted">' + e('Artwork opening ' + (size.svgOpening || size.opening || '')) + '</text>' +
        '<line x1="' + (pad - 10) + '" y1="' + base + '" x2="' + (width - pad + 10) + '" y2="' + base + '" stroke="#c9c2b6" stroke-width="1"/></svg>';
    }
    const pattern = detail.pattern || {};
    const reference = detail.reference || {};
    const refs = (detail.references || []).filter(function (item) { return item && item.src; });
    function carousel(items) {
      return '<figure class="pd-media pd-reference pd-carousel" data-pd-carousel aria-roledescription="carousel" aria-label="Pattern reference images">' +
        '<div class="pd-carousel-track" data-pd-track tabindex="0">' + items.map(function (item, index) {
          return '<div class="pd-carousel-slide" role="group" aria-label="' + (index + 1) + ' of ' + items.length + '"><img src="' + e(item.src) + '" alt="' + e(item.alt || '') + '" loading="lazy" decoding="async" draggable="false">' + (item.caption ? '<span class="pd-carousel-caption">' + e(item.caption + (item.credit ? ' · ' + item.credit : '')) + '</span>' : '') + '</div>';
        }).join('') + '</div>' +
        (items.length > 1 ? '<div class="pd-carousel-controls"><span class="pd-carousel-count" data-pd-count aria-live="polite">1 / ' + items.length + '</span><button type="button" class="pd-carousel-btn" data-pd-step="-1" aria-label="Previous reference image"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M20 12H4m6-6-6 6 6 6"/></svg></button><button type="button" class="pd-carousel-btn" data-pd-step="1" aria-label="Next reference image"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 12h16m-6-6 6 6-6 6"/></svg></button></div>' : '') +
        '</figure>';
    }
    const inspirationLink = '<a class="text-link" href="' + e(getHref('collection') + '?inspiration=' + (pattern.inspiration || '')) + '"><span>More from ' + e(pattern.inspirationLabel || 'this source') + '</span><span aria-hidden="true">→</span></a>';
    const frameSpecs = '<dl class="pd-specs"><div><dt>Framed size</dt><dd>' + e((detail.frame || {}).size || 'To be added') + '</dd></div><div><dt>Artwork opening</dt><dd>' + e((detail.frame || {}).opening || 'To be added') + '</dd></div><div><dt>Frame</dt><dd>Dark brown wood-grain face, slim red-brown edges</dd></div><div><dt>Corners</dt><dd>45° mitered</dd></div><div><dt>Display</dt><dd>' + e((product.specifications || {}).Display || 'To be added') + '</dd></div></dl>' + ((shared.frame || {}).note ? '<p class="pd-note">' + e(shared.frame.note) + '</p>' : '');
    const others = products.filter(function (entry) { return entry.slug !== product.slug; });
    const storyItems = helpers ? helpers.storyItems() : [];
    const stories = (detail.stories || []).map(function (slug) { return storyItems.find(function (item) { return item.slug === slug; }); }).filter(Boolean);
    const studio = shared.studio || {};
    root.innerHTML =
      '<section class="pd-section pd-split pd-pattern">' + (refs.length ? carousel(refs) : figure(img(reference), reference.alt, 'pd-reference', reference.src ? (reference.caption + (reference.credit ? ' · ' + reference.credit : '')) : '', reference.caption || 'Historical reference image to be added')) + copyBlock(pattern, inspirationLink) + '</section>' +
      '<section class="pd-section pd-full pd-craft">' + figure(img(detail.craft || product.images[1]), (detail.craft || product.images[1] || {}).alt, 'pd-wide') + copyBlock(shared.craft || {}, '', 'pd-center') + '</section>' +
      '<section class="pd-section pd-split pd-reverse pd-frame">' + copyBlock(shared.frame || {}, frameSpecs) + figure(window.FELT_ASSET('../assets/user/frame-fit-2026-10-11/' + product.slug + '/07-frame-corner.png'), product.title + ' frame corner', 'pd-square') + '</section>' +
      '<section class="pd-section pd-size">' + copyBlock(shared.size || {}, '', 'pd-center') + '<div class="pd-diagram-wrap">' + sizeDiagram() + '</div></section>' +
      '<section class="pd-section pd-space">' + copyBlock(shared.space || {}, '', 'pd-center') + '<div class="pd-two">' + ['04-desk', '03-wall'].map(function (name, k) { const asset = product.images.find(function (im) { return new RegExp('(/|__)' + name + '\\.').test(im.src || ''); }) || product.images[[3, 2][k]] || {}; /* 04-desk 立在书桌 + 03-wall 挂墙 */ return figure(img(asset), asset.alt, 'pd-square', asset.label); }).join('') + '</div></section>' +
      (helpers && others.length ? '<section class="pages-related-artwork pd-more"><h2>' + e((shared.more || {}).title || 'More artworks') + '</h2><ul class="pages-product-grid" data-grid="large">' + others.map(function (entry) { return helpers.productCard(ctx, entry); }).join('') + '</ul></section>' : '') +
      (helpers && stories.length ? '<section class="pages-related-stories pd-stories"><h2>' + e((shared.stories || {}).title || 'Related stories') + '</h2><div class="pages-story-grid">' + stories.map(function (item) { return helpers.storyCard(ctx, item); }).join('') + '</div>' + helpers.link(ctx, 'stories', 'All stories') + '</section>' : '') +
      '<section class="pd-section pd-split pd-studio">' + figure(studio.image, studio.alt, 'pd-landscape') + copyBlock(studio, '<a class="text-link" href="' + e(getHref('about')) + '"><span>' + e(studio.link || 'About') + '</span><span aria-hidden="true">→</span></a>') + '</section>';
    root.querySelectorAll('img').forEach(setImageFallback);
    root.querySelectorAll('[data-pd-carousel]').forEach(function (box) {
      const track = box.querySelector('[data-pd-track]'); const count = box.querySelector('[data-pd-count]');
      const total = track.children.length;
      const current = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
      const go = function (index) { index = (index + total) % total; track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' }); };
      let frame = 0;
      track.addEventListener('scroll', function () { cancelAnimationFrame(frame); frame = requestAnimationFrame(function () { if (count) count.textContent = (current() + 1) + ' / ' + total; }); }, { passive: true });
      box.querySelectorAll('[data-pd-step]').forEach(function (button) { button.addEventListener('click', function () { go(current() + Number(button.dataset.pdStep)); }); });
      track.addEventListener('keydown', function (event) { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); go(current() + (event.key === 'ArrowRight' ? 1 : -1)); } });
    });
  }
  function route(force) {
    const info = locationRoute();
    const requestedProduct = info.key === 'product' ? getProduct(info.productSlug) : defaultProduct;
    const page = info.key === 'product' && !requestedProduct ? 'product-not-found' : info.key;
    const productChanged = requestedProduct && requestedProduct !== product;
    if (requestedProduct) product = requestedProduct;
    if (productChanged || (page === 'product' && currentPage !== 'product')) { imageIndex = 0; quantity = 1; selectedSize = product.sizes[0].id; zoom = 1; pan = { x: 0, y: 0 }; gesture = null; }
    const anchorId = info.anchor;
    let title = page === 'product' ? product.title : 'Chinese-inspired wool felt art';
    if (page !== currentPage || currentProductRoute !== info.productSlug || force === true || !['home', 'product'].includes(page)) {
      if (typeof pageCleanup === 'function') { pageCleanup(); pageCleanup = null; }
      closeDialogs();
      if (page === 'native') { title = (window.FELT_ROUTE && window.FELT_ROUTE.title) || title; }
      else if (['home', 'product'].includes(page)) {
        main.replaceChildren(document.getElementById(page + '-template').content.cloneNode(true));
        fillContent(main);
        if (page === 'product') { drawSizes(); drawThumbnails(); updatePrimaryImage(); updateQuantity(); drawProductDetails(); pageCleanup = mountProductInteractions(); }
        else drawHomeSections();
      } else {
        const module = window.FELT_PAGES && window.FELT_PAGES.matches(page) ? window.FELT_PAGES : window.FELT_COMMERCE && window.FELT_COMMERCE.matches(page) ? window.FELT_COMMERCE : null;
        if (module) {
          main.innerHTML = module.render(page, pageContext());
          title = module.title(page);
          if (module.mount) pageCleanup = module.mount(main, page, pageContext());
          if (module !== window.FELT_PAGES) main.querySelectorAll('img').forEach(setImageFallback);
        } else if (page === 'product-not-found') {
          title = 'Artwork not found';
          main.innerHTML = '<section class="route-empty"><h1 tabindex="-1">Artwork not found</h1><p>This artwork is not in our collection. Choose an artwork from the collection.</p><a class="pill-button" href="' + getHref('collection') + '">Explore the collection</a></section>';
        } else main.innerHTML = '<section class="route-empty"><h1 tabindex="-1">Page not found</h1><p>This page could not be found.</p><a class="pill-button" href="' + getHref('home') + '">Back to home</a></section>';
      }
      currentPage = page;
      currentProductRoute = info.productSlug;
      document.body.dataset.page = page.split('/')[0];
    }
    if (page.indexOf('story/') === 0) document.title = title + ' · ' + content.brand.name;
    header.classList.remove('header-hidden');
    const anchor = anchorId && anchorId !== 'main' ? document.getElementById(anchorId) : null;
    if (anchor && main.contains(anchor)) {
      anchor.scrollIntoView({ block: 'start' });
      const heading = anchor.querySelector('h2'); if (heading) heading.focus({ preventScroll: true });
    } else {
      window.scrollTo(0, 0);
      const heading = anchorId === 'main' ? main : main.querySelector('h1'); if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
    }
    previousScroll = window.scrollY; syncHeader();
  }
  document.addEventListener('click', function (event) {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.hasAttribute('data-video-control')) {
      const video = target.closest('.home-hero').querySelector('video');
      if (video.paused) video.play().catch(function () { notify('The video could not play. The image remains available.'); });
      else video.pause();
      return;
    }
    if (target.hasAttribute('data-close')) { dismissDialog(target.closest('dialog')); return; }
    if (target.dataset.open) {
      if (target.dataset.open === 'menu') { resetMenu(); openDialog(menu, target); }
      else showPanel(target.dataset.open, target);
      return;
    }
    if (target.id === 'open-gallery') { updateGalleryImage(); openDialog(gallery, target); return; }
    if (target.hasAttribute('data-inline-step')) { changeImage(Number(target.dataset.inlineStep), false); return; }
    if (target.hasAttribute('data-gallery-step')) { changeImage(Number(target.dataset.galleryStep), true); return; }
    if (target.hasAttribute('data-thumbnail')) { imageIndex = Number(target.dataset.thumbnail); updatePrimaryImage(); return; }
    if (target.hasAttribute('data-quantity')) {
      quantity = Math.max(1, Math.min(9, quantity + Number(target.dataset.quantity))); updateQuantity();
      if (target.disabled) document.querySelector('[data-quantity="' + (quantity === 1 ? 1 : -1) + '"]').focus({ preventScroll: true });
      return;
    }
    if (target.hasAttribute('data-add')) {
      if (bagQuantity + quantity > 9) { notify('You can order up to 9 pieces at a time.'); return; }
      if (!product.sizes.some(function (size) { return size.id === selectedSize; })) return;
      if (!currentSize().variantId) { notify('This piece is not available to order yet. Email us at hello@motiffeltart.com.'); return; }
      const existing = bagItems.find(function (item) { return item.sku === product.sku && item.size === selectedSize; });
      if (existing) existing.quantity += quantity; else bagItems.push({ sku: product.sku, size: selectedSize, quantity: quantity });
      const saved = saveBag(); showPanel('bag', target);
      notify(saved ? 'Added to your bag.' : 'Added to the bag, but your browser could not save it.'); return;
    }
    if (target.hasAttribute('data-bag-quantity')) {
      const delta = Number(target.dataset.bagQuantity);
      const sizeId = target.dataset.bagSize;
      const sku = target.dataset.bagSku;
      const item = bagItems.find(function (record) { return record.sku === sku && record.size === sizeId; });
      if (!item || (delta > 0 && bagQuantity >= 9)) return;
      item.quantity = Math.max(1, Math.min(9, item.quantity + delta)); saveBag(); drawBag();
      const selector = '[data-bag-sku="' + CSS.escape(sku) + '"][data-bag-size="' + CSS.escape(sizeId) + '"]';
      let focus = drawer.querySelector(selector + '[data-bag-quantity="' + delta + '"]');
      if (focus && focus.disabled) focus = drawer.querySelector(selector + '[data-bag-quantity="' + (-delta) + '"]');
      if (focus) focus.focus({ preventScroll: true });
      return;
    }
    if (target.hasAttribute('data-remove')) { bagItems = bagItems.filter(function (record) { return record.sku !== target.dataset.bagSku || record.size !== target.dataset.remove; }); saveBag(); drawBag(); (drawer.querySelector('[data-remove]') || drawer.querySelector('.bag-continue')).focus({ preventScroll: true }); return; }
    if (target.tagName === 'A' && target.hasAttribute('href') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && target.target !== '_blank' && !target.hasAttribute('download')) {
      const href = target.getAttribute('href');
      const url = new URL(href, location.href);
      const localPage = url.origin === location.origin && url.pathname.replace(/[^/]+$/, '') === location.pathname.replace(/[^/]+$/, '') && (href.startsWith('#') || url.pathname.endsWith('.html'));
      if (!localPage) return;
      event.preventDefault();
      closeDialogs();
      if (href === '#main') { window.scrollTo(0, 0); main.focus({ preventScroll: true }); header.classList.remove('header-hidden'); previousScroll = 0; syncHeader(); return; }
      if (href === '#footer') { document.querySelector('footer').scrollIntoView(); document.querySelector('footer').focus({ preventScroll: true }); return; }
      if (url.href !== location.href) history.pushState(null, '', url.href);
      route();
      if (currentPage === 'product' && target.hasAttribute('data-view-index')) imageIndex = Math.max(0, Math.min(product.images.length - 1, Number(target.dataset.viewIndex) || 0));
      updatePrimaryImage();
    }
  });
  document.getElementById('dismiss-announcement').addEventListener('click', function () {
    document.getElementById('announcement').hidden = true;
    document.documentElement.style.setProperty('--notice', '0px');
    syncHeader();
    document.querySelector('.menu-trigger').focus({ preventScroll: true });
  });
  window.addEventListener('hashchange', route);
  window.addEventListener('popstate', function () { route(true); });
  window.addEventListener('storage', function (event) { if (event.key === storageKey) { loadBag(); if (drawer.open && drawer.dataset.panel === 'bag') drawBag(); if (['bag', 'checkout'].includes(currentPage)) route(true); } });
  setImageFallback(document.getElementById('gallery-image'));
  const productMenu = document.getElementById('menu-products');
  productMenu.querySelectorAll('a[data-copy="product.title"]').forEach(function (link) { link.remove(); });
  products.forEach(function (entry) { const link = textElement('a', entry.title, 'menu-link'); link.href = getProductUrl(entry); productMenu.append(link); });
  fillContent(document);
  document.querySelector('.wordmark').setAttribute('aria-label', content.brand.accessibleName + ' home');
  loadBag(); route();
})();
